module.exports = __webpack_public_path__ + "media/images/cloud-streams-emblem-d535b246cd853708522bf2ef1d2ac2d8.svg";